import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { produce } from 'immer';
import type { ReduxError } from '@universal/errors';
import { FaqType } from '../../../../types/faqType';

// Actions
export enum Actions {
  GET_FAQ = 'GET_FAQ',
  GET_FAQ_SUCCESS = 'GET_FAQ_SUCCESS',
  GET_FAQ_FAIL = 'GET_FAQ_FAIL',
  GET_FAQ_CANCEL = 'GET_FAQ_CANCEL',
}

export interface State {
  data?: FaqType[];
  meta: { isUpdating: boolean; fetchedAt?: string };
  error?: ReduxError;
}

export const initialState: State = {
  meta: {
    isUpdating: false,
  },
};

export const actions = {
  getFaq: createAsyncAction(
    Actions.GET_FAQ, // request payload creator
    Actions.GET_FAQ_SUCCESS, // success payload creator
    Actions.GET_FAQ_FAIL, // failure payload creator
    Actions.GET_FAQ_CANCEL, // optional cancel payload creator
  )<undefined, FaqType[], ReduxError, undefined>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getFaq.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.meta = {
        isUpdating: true,
        fetchedAt: draftState.meta.fetchedAt || undefined,
      };
    }),
  )
  .handleAction(actions.getFaq.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.meta = {
        isUpdating: false,
        fetchedAt: new Date().toISOString(),
      };
      draftState.data = action.payload;
    }),
  )
  .handleAction(actions.getFaq.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.meta = { isUpdating: false };
      draftState.error = action.payload;
    }),
  )
  .handleAction(actions.getFaq.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.meta = { isUpdating: false };
    }),
  );
